import React from "react"
import { useSelector } from "react-redux"
import { useNavigate, useLocation } from "react-router-dom"
import Button from "react-bootstrap/Button"
import "./index.scss"
import { ScheduleButtons } from "components"
import useT from "utils/hooks/useT"

function NavItem({ url, children }) {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <Button variant={location.pathname.startsWith(url) ? "primary" : "light"} onClick={() => navigate(url)}>
      {children}
    </Button>
  )
}

export default function AdminHeader() {
  const location = useLocation()
  const showProjects = useSelector((state) => state.teamStatus.showProjects)
  const showAnalyses = useSelector((state) => state.teamStatus.showAnalyses)
  const isMember = useSelector((state) => state.auth.isMember)
  const memberId = useSelector((state) => state.auth.memberId)
  const currentMemberShowOnPlan = useSelector((state) => state.auth.memberId && state.members[state.auth.memberId] ? state.members[state.auth.memberId].showOnPlan : true)
  const teamName = useSelector((state) => state.teamInfo.teamName)
  const teamLocation = useSelector((state) => state.teamInfo.location)
  const creatingOrEditingProject = location.pathname.includes("/setup/projects/")
  const { t } = useT("common")

  let dropDownOptions = []
  if (showProjects) {
    dropDownOptions.push({ url: "/scrum-view", name: t("scrumView") })
  }
  dropDownOptions.push({ url: "/", name: t("teamPlan") })
  if (showProjects) {
    dropDownOptions.push({ url: "/project-view", name: t("projectView") })
  }
  dropDownOptions.push({ url: "/asset-view", name: t("instrumentView") })
  if (showAnalyses) {
    dropDownOptions.push({ url: "/sample-view", name: t("sampleView") })
  }
  if (currentMemberShowOnPlan) {
    dropDownOptions.push({ url: `/member/${memberId}`, name: t("memberPlan") })
  }

  return (
    <>
      <ScheduleButtons type="settings-view" />
      {!isMember && !creatingOrEditingProject && (
        <div className="AdminHeader">
          <div className="TeamLocation">
            <p>{t("teamLabel", { name: teamName })}</p>
            <p>{t("locationColon", { name: teamLocation })}</p>
          </div>
          <div className="AdminHeader-nav">
            {<NavItem url="/setup/members">{t("team")}</NavItem>}
            {<NavItem url="/setup/assets">{t("instruments")}</NavItem>}
            {(showProjects || showAnalyses) && <NavItem url="/setup/competence-groups">{t("competenceGroups")}</NavItem>}
            {showAnalyses && !isMember && <NavItem url="/setup/analyses">{t("analyses")}</NavItem>}
            {showProjects && !isMember && <NavItem url="/setup/project-templates">{t("projectTemplates")}</NavItem>}
            {<NavItem url="/setup/integration">{t("integration")}</NavItem>}
            {!isMember && <NavItem url="/setup/advanced">{t("advanced")}</NavItem>}
          </div>
        </div>
      )}


      {/*
        <div className="DropDown">

        <DropdownButton
          title={
            dropDownOptions.find((el) => el.url === location.pathname)
              ? dropDownOptions.find((el) => el.url === location.pathname).name
              : "Views"
          }
          onSelect={(view) => history.push(view)}
        >
          {dropDownOptions.map((view) => {
            return (
              <Dropdown.Item key={view.url} active={view === location.pathname} eventKey={view.url}>
                {view.name}
              </Dropdown.Item>
            )
          })}
        </DropdownButton>
      </div>
        */}

    </>
  )
}
